import React, { forwardRef, useContext } from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';

import Show from 'components/Show';
import { Button } from 'components/Misc/Form';

import Question from 'components/Editor/blocks/Quiz/Question';
import Content from 'components/Editor/blocks/Quiz/Content';
import Option from 'components/Editor/blocks/Quiz/Option';

import { EditorContext } from 'components/Editor';

const Quiz = forwardRef(({ children, element, ...attributes }, ref) => {
	// Get editor's instance
	const editor = useSlateStatic();

	// Use editor's context
	const { quiz, onUpdateQuizMode } = useContext(EditorContext);

	// Handle question addition
	const onAdd = () => {
		const path = ReactEditor.findPath(editor, element);
		editor.insertQuizQuestion(path);
	};

	// Handle quiz answer check
	const onCheck = () => {
		onUpdateQuizMode('review');
	};

	// Handle quiz retry
	const onRetry = () => {
		onUpdateQuizMode('answer');
	};

	return (
		<div
			ref={ref}
			{...attributes}
			className="space-y-3 flex flex-col w-full"
		>
			{children}
			
			{/* Quiz's question addition */}
			{/* Show only if editable */}
			<Show if={quiz.mode === 'edit'}>
				<div contentEditable={false}>
					<Button
						icon="add"
						value="Pievienot jautājumu"
						onClick={onAdd}
					/>
				</div>
			</Show>

			{/* Quiz's answer check */}
			{/* Show only if answering */}
			<Show if={quiz.mode === 'answer'}>
				<div contentEditable={false} className="flex justify-end">
					<Button
						icon="check"
						theme="success"
						value="Pārbaudīt atbildes"
						onClick={onCheck}
					/>
				</div>
			</Show>

			{/* Quiz's answer check */}
			{/* Show only if reviewing */}
			<Show if={quiz.mode === 'review'}>
				<div contentEditable={false} className="flex justify-end">
					<Button
						icon="refresh"
						theme="success"
						value="Mēģināt vēlreiz"
						onClick={onRetry}
					/>
				</div>
			</Show>
		</div>
	);
});

export {
	Quiz,
	Question,
	Content,
	Option
};